// import React, { useState } from "react";
// import {
//   Select,
//   FormControl,
//   MenuItem,
//   Stack,
//   Grid,
//   InputLabel,
//   Chip,
//   Box,
//   TextField,
//   Autocomplete,
//   Typography,
// } from "@mui/material";

// function Dropdown({ onVariantChange, currentVariant }) {
//   const [selectedValue, setSelectedValue] = useState([]);
//   const [firstDropdownValue, setFirstDropdownValue] = useState("");

//   const sizeValue = ["S", "M", "L"];
//   const colorValue = ["Red", "Green", "Blue"];

//   const handleFirstDropdownChange = (event) => {
//     const { value } = event.target;
//     setFirstDropdownValue(value);
//     setSelectedValue([]); // Reset selected values when changing dropdown
//     onVariantChange("variantName", value); // Update variantName
//   };

//   const handleChange = (event, newValue) => {
//     setSelectedValue(newValue);
//     onVariantChange("variantValue", newValue); // Update variantValue
//   };

//   // Handle chip deletion
//   const handleDelete = (chipToDelete) => {
//     const filteredValues = selectedValue.filter(
//       (name) => name !== chipToDelete
//     );
//     setSelectedValue(filteredValues);
//     onVariantChange("variantValue", filteredValues);
//   };

//   return (
//     <Box
//       sx={{
//         padding: "20px",
//         border: "1px solid #DCE0E4",
//         borderRadius: "10px",
//         marginTop: 3,
//       }}
//     >
//       <Typography
//         sx={{
//           fontWeight: 700,
//           fontSize: "16px",
//           color: "background: rgba(28, 38, 48, 1)",
//         }}
//       >
//         Add Variant
//       </Typography>
//       <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
//         <Grid item>
//           <FormControl
//             fullWidth
//             sx={{
//               mt: 1,
//               minWidth: "18vw",
//               minHeight: "35px",
//               marginLeft: "0px",
//             }}
//             size="small"
//           >
//             <Select
//               value={firstDropdownValue}
//               onChange={handleFirstDropdownChange}
//               displayEmpty
//               fullWidth
//               sx={{ height: "35px" }}
//             >
//               <MenuItem value="" disabled>
//                 Select
//               </MenuItem>
//               <MenuItem value="size">Size</MenuItem>
//               <MenuItem value="color">Color</MenuItem>
//               <MenuItem value="custom">Custom</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item>
//           <Autocomplete
//             sx={{
//               mt: 1,
//               minWidth: "18vw",
//               minHeight: "35px",
//               marginLeft: "0px",
//             }}
//             size="small"
//             multiple
//             id="autocomplete-chips"
//             options={
//               firstDropdownValue === "size"
//                 ? sizeValue
//                 : firstDropdownValue === "color"
//                 ? colorValue
//                 : []
//             }
//             value={selectedValue}
//             onChange={handleChange}
//             freeSolo
//             fullWidth
//             renderInput={(params) => (
//               <TextField {...params} variant="outlined" size="small" />
//             )}
//             renderTags={(value, getTagProps) => (
//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                 {value.map((option, index) => (
//                   <Chip
//                     key={option}
//                     label={option}
//                     {...getTagProps({ index })}
//                     onDelete={() => handleDelete(option)}
//                   />
//                 ))}
//               </Box>
//             )}
//           />
//         </Grid>
//       </Stack>
//     </Box>
//   );
// }

// export default Dropdown;
import React, { useState } from "react";
import {
  Select,
  FormControl,
  MenuItem,
  Stack,
  Grid,
  Chip,
  Box,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";

function Dropdown({ onVariantChange, currentVariant }) {
  const [selectedValue, setSelectedValue] = useState(
    currentVariant.variantValue || []
  );
  const [firstDropdownValue, setFirstDropdownValue] = useState(
    currentVariant.variantName || ""
  );

  const sizeValue = ["S", "M", "L"];
  const colorValue = ["Black", "White", "Green"];

  const handleFirstDropdownChange = (event) => {
    const { value } = event.target;
    setFirstDropdownValue(value);
    setSelectedValue([]); // Reset selected values when changing dropdown
    onVariantChange("variantName", value); // Update variantName
  };

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
    onVariantChange("variantValue", newValue); // Update variantValue
  };

  const handleDelete = (chipToDelete) => {
    const filteredValues = selectedValue.filter(
      (name) => name !== chipToDelete
    );
    setSelectedValue(filteredValues);
    onVariantChange("variantValue", filteredValues);
  };

  return (
    <Stack direction={"row"} sx={{ marginTop: "20px", width: "100%" }} gap={3}>
      <Box sx={{ flex: 1, minWidth: "18vw" }}>
        <FormControl fullWidth size="small">
          <Select
            value={firstDropdownValue}
            onChange={handleFirstDropdownChange}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            <MenuItem value="size">Size</MenuItem>
            <MenuItem value="color">Color</MenuItem>
            <MenuItem value="custom">Custom</MenuItem>
          </Select>
        </FormControl>
        <Typography
          sx={{
            fontSize: "12px",
            color: "rgba(28, 38, 48, 1)",
            marginTop: "8px",
          }}
        >
          Select predefined variant or create a new one
        </Typography>
      </Box>

      <Box sx={{ flex: 1, width: "100%" }}>
        <Autocomplete
          size="small"
          multiple
          id="autocomplete-chips"
          options={
            firstDropdownValue === "size"
              ? sizeValue
              : firstDropdownValue === "color"
              ? colorValue
              : []
          }
          value={selectedValue}
          onChange={handleChange}
          freeSolo
          renderInput={(params) => (
            <TextField {...params} variant="outlined" size="small" fullWidth />
          )}
          renderTags={() => null}
        />
        <Box
          sx={{ display: "flex", flexWrap: "wrap", gap: 1, marginTop: "8px" }}
        >
          {selectedValue.map((tag, index) => {
            let backgroundColor;
            if (tag === "Black") {
              backgroundColor = "rgba(28, 38, 48, 1)";
            } else if (tag === "White") {
              backgroundColor = "#FFF";
            } else if (tag === "Green") {
              backgroundColor = "rgba(0, 158, 131, 1)";
            } else {
              backgroundColor = null; // No avatar for other tags
            }

            return (
              <Chip
                sx={{
                  backgroundColor: "rgba(238, 238, 238, 1)",
                  fontSize: "14px",
                  fontWeight: 500,
                  height: "28px",
                  paddingY: "6px"
                }}
                key={index}
                icon={
                  backgroundColor && (
                    <Box
                      sx={{
                        width: "16px",
                        height: "16px",
                        backgroundColor,
                        borderRadius: "100%",
                      }}
                    />
                  )
                }
                label={tag}
                onDelete={() => {
                  setSelectedValue((prev) =>
                    prev.filter((_, i) => i !== index)
                  );
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Stack>
  );
}

export default Dropdown;
